import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AppComponent } from '../../app.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent {
  private router = inject(Router);
  private appComponent = inject(AppComponent);
  private _auth = inject(AuthService);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  @Output() sendStatusEvent = new EventEmitter<boolean>();

  getLoggedInRolename() {
    return sessionStorage.getItem("roleName");
  }

  getAdvanceLink() {
    const loggedInCompanyId = sessionStorage.getItem("companyId");
    return "/advanceList/" + Number(loggedInCompanyId);
  }

  getCustomerListLink() {
    const loggedInCompanyId = sessionStorage.getItem("companyId");
    return "/customerList/" + Number(loggedInCompanyId);
  }

  checkDashboard() {
    if (this.sharedService.isRoles([this.enums.ADMIN, this.enums.BOSS, this.enums.FINANCE, this.enums.ADMIN_HEAD]))
      return "/dashboard-admin"
    else
      return "/dashboard-calendar"
  }

  getStyle(routeUrl: string) {
    return (this.router.url == routeUrl) ? "active" : "inactive";
  }

  getSubmenuStyle() {
    return (this.router.url == '/assetList' || this.router.url == '/assetGroupList' || this.router.url == '/vendorList') ? "submenuActive" : "inactive";
  }

  toggleSidebar() {
    this.appComponent.toggleSidebar();
  }

  getReceiptMenu() {
    if (this.sharedService.isAdmin())
      this.router.navigate(['/receiptList']);
    else {
      // var companyId = Number(sessionStorage.getItem("companyId"))
      // var addADayDate = new Date(Number(new Date()) + (3600 * 1000 * 24) - 1);

      // this.router.navigate(['/receiptList', companyId, new Date().toISOString(), addADayDate.toISOString(), false]);
      this.router.navigate(['/receiptList']);
    }

    this.toggleSidebar();
  }

  logout() {
    this._auth.logout();
  }

}
